@import './pn-mainnav-common.scss';
@import '../../../globals/main.scss';

pn-mainnav-link {
  display: block;
  button,
  a {
    font-weight: normal;
    position: relative;
    border: 0 none;
    display: flex;
    align-items: center;
    background-color: transparent;
    color: $blue700;

    &:hover,
    &:focus {
      background-color: $white;
      color: $blue700;
      outline: 0;
      box-shadow: none;
    }
    &:active {
      background-color: $gray50;
      color: $blue400;
      box-shadow: none;
    }
  }
}

pn-mainnav-link {
  [data-level='1'] & {
    @media screen and (min-width: $mobilenav-media-abovemobilemode) {
      height: 100%;
      padding-left: 0;
      position: relative;
      scroll-snap-align: center;
    }
    &:first-child {
      border-top: 0.1rem solid $gray50;

      @media screen and (min-width: $mobilenav-media-abovemobilemode) {
        border: 0;
      }
    }

    > button,
    > a {
      font-size: 2rem;
      width: 100%;
      border-bottom: 0.1rem solid $gray50;
      height: auto;
      padding: 1.9rem 0 1.9rem 3rem;

      @media screen and (min-width: $mobilenav-media-abovemobilemode) {
        height: 100%;
        border: 0;
        font-size: 1.6rem;
        font-weight: normal;
        position: relative;
        outline: 0;
        overflow: hidden;
        padding: 1.6rem 1.6rem;
        white-space: nowrap;

        &::before {
          content: '';
          background-color: $blue400;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.5em;
          border-radius: 0.5em 0.5em 0 0;
          transform: translateY(100%);
          transition: transform 0.1s cubic-bezier(0.64, 0.01, 0.67, 0.92);
        }

        &:hover,
        &:focus {
          &::before {
            transform: translateY(0);
          }
        }

        &:active {
          outline: 0;
          box-shadow: none;
          color: $blue700;

          &::before {
            background-color: $blue200;
            transform: translateY(0);
          }
        }
      }

      &:hover,
      &:focus {
        @media screen and (min-width: $mobilenav-media-abovemobilemode) {
          text-decoration: none;
        }
      }

      &[aria-expanded='true'] {
        &::before {
          @media screen and (min-width: $mobilenav-media-abovemobilemode) {
            content: '';
            background-color: $blue400;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 0.5em;
            border-radius: 0.5em 0.5em 0 0;
            transform: translateY(0);
            transition: transform 0.1s cubic-bezier(0.64, 0.01, 0.67, 0.92);
          }
        }
      }
    }

    [aria-expanded='true'] {
      .first-level_icon {
        transform: rotateX(180deg);
      }
    }

    pn-icon {
      &.first-level_icon {
        transition: 0.25s linear transform;
        width: 1.92rem;
        height: 1.92rem;
        display: none;

        @media screen and (min-width: $mobilenav-media-abovemobilemode) {
          display: block;
        }
      }

      &.first-level_arrow {
        display: block;

        @media screen and (min-width: $mobilenav-media-abovemobilemode) {
          display: none;
        }

        position: absolute;
        height: 2.4rem;
        width: 2.4rem;
        right: 2.4rem;
        top: 50%;
        transform: translateY(-50%);
      }

      svg {
        pointer-events: none;
        speak: none;
        width: 100%;
        height: 100%;
      }
    }
  }
}

pn-mainnav-link {
  // Additional links added to a level 2 section should not have the min-width required to make the columns look good
  pn-mainnav-level[data-level='2']:not([data-level-listcount='1']) pn-mainnav-list:last-child & {
    > a {
      @media screen and (min-width: $mobilenav-media-abovemobilemode) {
        min-width: unset;
      }
    }
  }
  [data-level='2'] & {
    position: static;
    display: inline-block;
    width: 100%;
    height: auto;

    @media screen and (min-width: $mobilenav-media-abovemobilemode) {
      padding-left: 0;
      margin-bottom: 1.6rem;
    }

    > a {
      font-size: 1.6rem;
      border-bottom: 0.1rem solid $gray50;
      padding: 2.2rem 0 2.2rem 3rem;
      white-space: normal;

      @media screen and (min-width: $mobilenav-media-abovemobilemode) {
        min-width: 16em;
        border: 0;
        border-radius: 1rem;
        padding: 1.4rem 1.6rem;
      }

      &:hover {
        background-color: $white;
        color: $blue700;
      }

      &:hover,
      &:focus {
        box-shadow: none;

        @media screen and (min-width: $mobilenav-media-abovemobilemode) {
          background-color: $gray50;
          color: $blue700;
          text-decoration: underline;
          outline: 0;
        }
        &::before {
          content: none;
        }
      }

      &:active {
        box-shadow: none;

        @media screen and (min-width: $mobilenav-media-abovemobilemode) {
          background-color: $gray50;
          color: $blue400;
          outline: 0;
        }

        &::before {
          content: none;
        }
      }
    }

    pn-icon {
      display: inline-block;
      margin-left: 0.2em;
      min-width: 1.5rem;
      width: 1.5rem;
      height: 1.5rem;
    }
  }
}
